// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"round"},"children":[{"tag":"circle","attrs":{"id":"fill1","cx":12,"cy":12,"r":7,"fill":"props.fillColor1"}},{"tag":"circle","attrs":{"id":"stroke1","cx":12,"cy":12,"r":7,"stroke":"props.strokeColor1","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const RoundIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'round',
    ref,
    icon: element,
  },
));

RoundIcon.displayName = 'RoundIcon';

export default RoundIcon;
